import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const { userInfo } = useSelector((state) => state.user);
  const location = useLocation();

  if (!userInfo) {
    return <Navigate to='/login' state={{ from: location }} replace />;
  }

  if (!userInfo.active) {
    return <Navigate to='/verify-email' replace />;
  }

  return children;
};

export default ProtectedRoute;
